module.exports = require("./it-CH.d.ts");